import { aspectRatio as ar } from "../../../../../../../common/parameters";

export interface IGetImageDimensionsThis {
    img: HTMLImageElement,
    setState: (stateChange: any) => void

}
export const getImageDimensions = function (this: IGetImageDimensionsThis) {
    let margin = 40;
    let width = Math.min(this.img.naturalWidth, ar.width - margin);
    let height = Math.min((this.img.naturalHeight / this.img.naturalWidth) * width, ar.height - 100 - margin);
    width = Math.ceil((this.img.naturalWidth / this.img.naturalHeight) * height);
    height = Math.ceil(height);
    let zoom = this.img.naturalWidth / width;
    this.setState({
        width,
        height,
        zoom,
    });

    return { width, height, zoom };
};
